import type { CSSProperties, ReactNode } from "react";
import { Cell } from "react-aria-components";
import clsx from "clsx";

import styles from "./table-cell.module.css";

interface TableCellProps {
  align?: "left" | "right" | "center";
  className?: string;
  children?: ReactNode;
  state?: "neutral" | "error" | "edit";
  display?: {
    padding?: "none" | "small" | "medium";
    height?: number;
  };
  /** Indicates how many columns the data cell spans. **/
  colSpan?: number;
}

function TableCell({
  align,
  className,
  children,
  state = "neutral",
  display,
  colSpan = 1,
}: TableCellProps) {
  const padding = display?.padding || "medium";
  const alignment = align || "left";

  let style: CSSProperties = {};
  if (display?.height) {
    style = { ...style, height: display.height };
  }

  return (
    <Cell
      colSpan={colSpan}
      style={style}
      className={clsx(
        styles.cell,
        styles[alignment],
        styles.horizontalPadding,
        className,
        {
          [styles.error]: state === "error",
          [styles.edit]: state === "edit",
          [styles.paddingSmall]: padding === "small",
          [styles.paddingMedium]: padding === "medium",
          [styles.paddingNone]: padding === "none",
        },
      )}
    >
      {children}
    </Cell>
  );
}

export default TableCell;
